var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{staticClass:"myoverLay",attrs:{"show":_vm.show,"lock-scroll":false}},[_c('div',{staticClass:"empty",on:{"click":function($event){_vm.$parent[_vm.showField] = false}}}),_vm._t("overBox")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }